// Pure helpers for resolving which email template should be selected for a
// given audience on the Customise Invitations screen. Kept separate from the
// component so the per-audience retention logic is unit-testable without
// rendering the editor.

// AUDIENCE ids used across the invites screen: Staff = 1, Parent = 2, Student = 4.
export const savedTemplateIdForAudience = (survey, audience) => {
  if (!survey) return 0
  if (audience === 1) return survey.staffEmailTemplateId || 0
  if (audience === 2) return survey.parentEmailTemplateId || 0
  if (audience === 4) return survey.pupilEmailTemplateId || 0
  return 0
}

// Resolve the template to select for the current audience. Falls back to the
// first template when the survey has no saved template for that audience, or
// when the saved id is not present in the fetched list (guards against the
// old `templates[-1] === undefined` blank-field bug). Returns null only when
// there are no templates at all.
export const resolveSelectedTemplate = (templates, audience, survey) => {
  const list = Array.isArray(templates) ? templates : []
  if (list.length === 0) return null
  const savedId = savedTemplateIdForAudience(survey, audience)
  const match = savedId > 0 ? list.find(t => t && t.id === savedId) : null
  return match || list[0]
}
